import { createSlice } from '@reduxjs/toolkit';

const tripSlice = createSlice({
  name: 'trip',
  initialState: {
    tripUpComingData: [],
    tripUpComingDataIsLoading: false,
    tripUpComingDataErrorMsg: null,

    completedTripsData: [],
    completedTripsDataIsLoading: false,
    completedTripsDataErrorMsg: null,
  },
  reducers: {
    tripUpComingReq: (state, action) => { },
    tripUpComingSuccess: (state, action) => ({
      ...state,
      tripUpComingData: action.payload,
      tripUpComingDataIsLoading: false,
      tripUpComingDataErrorMsg: null,
    }),
    tripUpComingFailure: (state, action) => ({
      ...state,
      tripUpComingDataIsLoading: false,
      tripUpComingDataErrorMsg: action.payload,
    }),
    tripUpComingLoading: (state) => ({
      ...state,
      tripUpComingDataIsLoading: true,
      tripUpComingDataErrorMsg: null,
    }),
    tripUpComingClear: (state) => ({
      ...state,
      tripUpComingData: [],
      tripUpComingDataIsLoading: false,
      tripUpComingDataErrorMsg: null,
    }),

    completedTripsReq: (state, action) => { },
    completedTripsSuccess: (state, action) => ({
      ...state,
      completedTripsData: action.payload,
      completedTripsDataIsLoading: false,
      completedTripsDataErrorMsg: null,
    }),
    completedTripsFailure: (state, action) => ({
      ...state,
      completedTripsDataIsLoading: false,
      completedTripsDataErrorMsg: action.payload,
    }),
    completedTripsLoading: (state) => ({
      ...state,
      completedTripsDataIsLoading: true,
      completedTripsDataErrorMsg: null,
    }),
    completedTripsClear: (state) => ({
      ...state,
      completedTripsData: [],
      completedTripsDataIsLoading: false,
      completedTripsDataErrorMsg: null,
    }),
  },
});

export const {
  tripUpComingClear,
  tripUpComingFailure,
  tripUpComingLoading,
  tripUpComingReq,
  tripUpComingSuccess,

  completedTripsClear,
  completedTripsFailure,
  completedTripsLoading,
  completedTripsReq,
  completedTripsSuccess,
} = tripSlice.actions;

export default tripSlice.reducer;
